import i18n from '../i18n';

const localeMap = {
  ru: 'ru-RU',
  en: 'en-US',
  zh: 'zh-CN'
};

export const getLocale = () => {
  const lang = (i18n.language || 'ru').split('-')[0];
  return localeMap[lang] || 'ru-RU';
};

export const formatDate = (value, options) => {
  if (!value) return '-';
  try {
    const date = value instanceof Date ? value : new Date(value);
    return date.toLocaleDateString(getLocale(), options);
  } catch (e) {
    return String(value);
  }
};

export const formatTime = (value, options) => {
  if (!value) return '-';
  try {
    const date = value instanceof Date ? value : new Date(value);
    return date.toLocaleTimeString(getLocale(), options);
  } catch (e) {
    return String(value);
  }
};

export const formatDateTime = (value, options) => {
  if (!value) return '-';
  try {
    const date = value instanceof Date ? value : new Date(value);
    return date.toLocaleString(getLocale(), options);
  } catch (e) {
    return String(value);
  }
};

export const formatNumber = (value, options) => {
  if (value === null || value === undefined || value === '') return '-';
  try {
    const num = typeof value === 'number' ? value : Number(value);
    if (Number.isNaN(num)) return String(value);
    return num.toLocaleString(getLocale(), options);
  } catch (e) {
    return String(value);
  }
};
